import { Trans } from "@lingui/react/macro";
import { Link } from "@tanstack/react-router";

import type { components } from "@/shared/api";
import { Button } from "@/shared/ui/button";

import { AnalysisLinkLabel } from "./AnalysisLinkLabel";

type AnalysisStatus = components["schemas"]["AnalysisStatus"];

type MatchAnalysisActionProps = {
  matchId: number;
  analysisStatus: AnalysisStatus | null;
  hasAnalysis: boolean;
  isStarting: boolean;
  disabled: boolean;
  onStart: (matchId: number) => void;
};

// Действие в строке матча: ссылка на разбор, если он есть, иначе кнопка «Разобрать».
export const MatchAnalysisAction = ({
  matchId,
  analysisStatus,
  hasAnalysis,
  isStarting,
  disabled,
  onStart,
}: MatchAnalysisActionProps) => {
  if (hasAnalysis) {
    return (
      <Button asChild variant="link" size="sm">
        <Link to="/matches/$matchId" params={{ matchId }}>
          <AnalysisLinkLabel status={analysisStatus} />
        </Link>
      </Button>
    );
  }
  return (
    <Button
      variant="outline"
      size="sm"
      disabled={disabled}
      loading={isStarting}
      onClick={() => {
        onStart(matchId);
      }}
    >
      {isStarting ? <Trans>Starting…</Trans> : <Trans>Analyze</Trans>}
    </Button>
  );
};
